module.exports = __webpack_public_path__ + "img/vehicle-options-white-hyundai.f3c15a3f.png";